import styled from '@emotion/styled';
import type { FC, ReactNode } from 'react';

import { Anchor } from 'src/components/common/atoms';
import { media } from 'src/styles';

type Props = {
  className?: string;
  isSingle: boolean;
  title?: ReactNode | null;
  meta?: {
    date?: string | null;
    category?: string | null;
  } | null;
  to?: string;
};

export const EntryHeader: FC<Props> = ({
  className,
  isSingle,
  title,
  meta,
  to,
}) => {
  return (
    <Header className={className ?? ''} as={isSingle ? 'div' : 'header'}>
      <Title as={isSingle ? 'h1' : 'h2'}>
        {to ? (
          isSingle ? (
            title
          ) : (
            <StyledAnchor to={to}>{title}</StyledAnchor>
          )
        ) : (
          title
        )}
      </Title>
      {meta && (
        <Meta>
          {meta.date}
          {meta.category}
        </Meta>
      )}
    </Header>
  );
};

const StyledAnchor = styled(Anchor)`
  text-decoration: none;
  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }
`;

const Title = styled.h2`
  line-height: 1.6;
  font-size: ${({ theme }) => theme.font.size.mediumLarge};
  ${media.greaterThanSiteBreakpoint} {
    font-size: ${({ theme }) => theme.font.size.large};
  }
`;

const Meta = styled.time`
  min-width: 6.5em;
  text-align: right;
  line-height: 1.6;
  font-size: ${({ theme }) => theme.font.size.small};
  ${media.greaterThanSiteBreakpoint} {
    font-size: ${({ theme }) => theme.font.size.large};
  }
`;

const Header = styled.div`
  --border-position-top: -9px;
  --border-width: 30px;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    z-index: 1;
    top: var(--border-position-top);
    left: 0;
    display: block;
    width: var(--border-width);
    height: 0;
    border-bottom: 1px solid black;
  }
  ${media.greaterThanSiteBreakpoint} {
    --border-position-top: -16px;
    --border-width: 60px;
  }
`;

export default EntryHeader;
